import { MutationTree } from 'vuex';
import { ConfigurationInfoState } from './types';
import { ConstructionConfigurationInfo } from '@/models';

export const mutations: MutationTree<ConfigurationInfoState> = {
  STORE(state, data: ConstructionConfigurationInfo) {
    state.configurationInfo = data
  },
  CLEAR(state) {
    state.configurationInfo = null
  }
}
